var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-dropdown", class: { "k-dropdown--caret": _vm.caret } },
    [
      _c(
        "div",
        { on: { click: _vm.toggleOpen } },
        [
          _vm._t("button"),
          _vm._v(" "),
          _vm.caret
            ? _c("span", { staticClass: "k-dropdown__caret" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "12",
                      height: "6",
                      xmlns: "http://www.w3.org/2000/svg",
                      id: "chevron-down",
                      viewBox: "0 0 12.17 6.465"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M.136.78l5.628 5.554a.457.457 0 0 0 .641 0L12.034.781a.456.456 0 1 0-.641-.649L6.085 5.365.777.131A.456.456 0 1 0 .136.78z"
                      }
                    })
                  ]
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "k-dropdown__menu",
                class: {
                  "k-dropdown__menu--right": _vm.position == "right",
                  "k-dropdown__menu--left": _vm.position == "left",
                  "k-dropdown__menu--overlay": _vm.position == "overlay"
                }
              },
              [_vm._t("dropdown")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }